'use strict';

// ::::::::::::::::::::::::::::::::::::::::::::: file description
// :: 
// :: this is the main file
// :: 
// :: 

// ::::::::::::::::::::::::::::::::::::::::::::: imports

// :::::::::::::::::: utils
import './jqueryGlobal.js';
import { EventEmitter, Observer, Mapolator, getMsBrowser } from './util';
//import $ from 'jquery';
import c from './config.js';

// :::::::::::::::::: general
import Memory from './memory';
import Navigation from './navigate';
import Gallery from './gallery';
import Loading from './loading';
import UrlUtils from './urlUtils';
import Tracker from './tracker';
import Bdsg from './bdsg';

// :::::::::::::::::: content
import Vimeo from '@vimeo/player';

// ::::::::::::::::::::::::::::::::::::::::::::: variables

// :::::::::::::::::: globals
// jquery
//window.$ = $;
// config
window.c = c;
// if you need events from static class
window.staticEvents = new EventEmitter();

// :::::::::::::::::: Views

// :::::::::::::::::: Memory
const memory = new Memory();

// :::::::::::::::::: navigation
const nav = new Navigation();

// :::::::::::::::::: gallery
const gallery = new Gallery();

// :::::::::::::::::: loading
const loading = new Loading();

// :::::::::::::::::: tracker
const tracker = new Tracker();

// :::::::::::::::::: bdsg
const bdsg = new Bdsg();

// :::::::::::::::::: url analyzer
//const urlHandler = new UrlHandler(); 

// ::::::::::::::::::::::::::::::::::::::::::::: events

window.staticEvents.addListener('navigate', (data) => {
    const isAlreadyHome = location.href.endsWith('home');
    const goesHome = data === 'home';
    nav.navigate(data); 
    
    if (goesHome && !isAlreadyHome) {
        gallery.next(1);
    } else {
        gallery.stop();
    }
});

// :::::::::::::::::: responsive

const resize = () => {
	clearTimeout(window.resizeTimer);
	window.resizeTimer = setTimeout(() => {

		const wr = window.innerWidth/1280.0;
		const hr = window.innerHeight/768.0;
		const ratio = Mapolator(Math.min(hr,wr), 0.0, 1, 0, 1, true);
		const anti100 = 100.0 / ratio;
		const anti50 = Mapolator(anti100, 100, 200, 0, 50, false);
		const container = $('#maincontainer');

        container.css({
          '-webkit-transform' : 'scale(' + ratio + ')',
          '-moz-transform'    : 'scale(' + ratio + ')',
          '-ms-transform'     : 'scale(' + ratio + ')',
          '-o-transform'      : 'scale(' + ratio + ')',
          'transform'         : 'scale(' + ratio + ')',
          'width'         : anti100 + '%',
          'height'        : anti100 + '%',
          'top'           : '-' + anti50 + '%',
          'left'           : '-' + anti50 + '%',
        });
        window.cRatio = ratio;
        window.cScale = 1.0 / ratio;
        window.staticEvents.emit('resize');
        
        //$('.container.bottom > .face > .svg').each((i,e) => {
            //const svg = $(e).children('svg').first();
            //const ratio = ($(e).height()/svg.height());
            //console.log([ratio,e,$(e).height(),svg.height()]);

			//svg.css({
			  //'-webkit-transform' : 'scale(' + ratio + ')',
			  //'-moz-transform'    : 'scale(' + ratio + ')',
			  //'-ms-transform'     : 'scale(' + ratio + ')',
			  //'-o-transform'      : 'scale(' + ratio + ')',
			  //'transform'         : 'scale(' + ratio + ')'
            //});
        //});

	}, 100);
}

// :::::::::::::::::: init function

function init() {
	$('body').addClass('desktop');
    $(window).resize(() => {
        resize();
    });
    resize();
    // hate
    if (getMsBrowser()) {
        $('body').addClass('ms-browser');
        $('body').addClass('ms-'+getMsBrowser());
    }
    bdsg.init();
	tracker.init();
    UrlUtils.init();
}

// ::::::::::::::::::::::::::::::::::::::::::::: initialization

$(document).ready(() => {
	init();
	console.log('You are currently viewing the console output of a web application. Enjoy.');
});

//const md = new MobileDetect(window.navigator.userAgent);
//if (md.mobile() !== null) {
	//console.log('mobile');
//} else {
	//console.log('not mobile');
//}
